Monitoring.Views.Dashboards ||= {}

class Monitoring.Views.MovistarTagsConditionEditView extends Backbone.View
  className: 'tags-group-filter'
  template: JST["backbone/templates/monitoring/movistar_rules/movistar_tags_condition_edit"]

  events:
    'change select.tags': 'onAddTag'
    'click li.listed-tag': 'onRemoveTag'
    'click .show-hierarchy': 'showHierarchy'
    'change input[name=tags-logic]': 'onChangeTagsLogic'
    'click #clear-tags-from-list': 'clearAll'

  initialize: (@options = {}) ->
    @id = @options.id
    @possibleTags = @options.possibleTags
    @appliedTags = @options.appliedTags
    @title = @options.title
    @logic = @options.logic
    @disabled = false # true when other view has a custom tag (allTags, noTags)

  render : ->
    @$el.html(@template(@))
    @initializeChosen()
    @

  initializeChosen: ->
    select = @$el.find('select.tags')
    select.chosen({width: '82%', search_contains: true})
    chosenDrop = @$el.find('.chosen-drop').hide()
    select.on('chosen:showing_dropdown', -> chosenDrop.show())
    select.on('chosen:hiding_dropdown', -> chosenDrop.hide())

  getSelectedTagCodes: ->
    _.pluck(@appliedTags, 'code')

  getSelectedLogic: ->
    @logic

  showHierarchy: ->
    unless @codeToDescription
      @codeToDescription = {}
      _.each(@possibleTags, (tag) => @codeToDescription[tag.code] = tag.description)
    @tagsHierarchyView = new Monitoring.Views.Dashboards.TagsHierarchyModalView({
      firstLevelNodes: Keepcon.currentAccount.hierarchy.root.children
      currentTags: @getSelectedTagCodes()
      translator: @codeToDescription
    })
    @listenTo(@tagsHierarchyView, 'selected:tags', @onChangeTagsFromHierarchy)
    @$el.append(@tagsHierarchyView.render().el)
    @showModal()

  onChangeTagsFromHierarchy: (newTagsCodes) ->
    @hideModal()
    @appliedTags = _.filter(@possibleTags, (tag) -> tag.applied = _.contains(newTagsCodes, tag.code))
    setTimeout =>
      @render()
    , 500

  onAddTag: (evt) ->
    tagCode = $(evt.currentTarget).val()
    if tagCode in ['allTags', 'noTags']
      @onAddCustomTag(tagCode)
    else
      @addTag(tagCode)
      @render()

  onAddCustomTag: (tagCode) ->
    swal({
      title: "Adding this tag will delete both Main and Secondary tags added. Are you sure?",
      type: 'info',
      showCancelButton: true,
      cancelButtonText: 'Cancel',
      confirmButtonText: 'Ok',
      closeOnConfirm: true
    }, (isConfirm) =>
      if (isConfirm)
        @clearAll()
        @addTag(tagCode)
        @trigger('added:customTag')
    )

  addTag: (tagCode) ->
    _.each(@possibleTags, (tag) =>
      if tagCode == tag.code
        tag.applied = true
        @appliedTags.push(tag)
    )

  onRemoveTag: (evt) ->
    tagCode = $(evt.currentTarget).data('code')
    if tagCode in ['allTags', 'noTags']
      @onRemoveCustomTag(tagCode)
    else
      @removeTag(tagCode)
      @render()

  onRemoveCustomTag: (tagCode) ->
    @removeTag(tagCode)
    @trigger('removed:customTag')

  removeTag: (tagCode) ->
    _.each(@possibleTags, (tag) =>
      if tagCode == tag.code
        tag.applied = false
        @appliedTags = _.without(@appliedTags, tag)
    )

  disable: ->
    @disabled = true
    @render()

  enable: ->
    @disabled = false
    @render()

  mustHideHierarchy: ->
    @disabled or not Keepcon.currentAccount.hierarchy?

  clearAll: ->
    @appliedTags = []
    _.each(@possibleTags, (tag) -> tag.applied = false)
    @render()
    @trigger('removed:customTag')

  showModal: =>
    @$el.find('#tags-hierarchy-modal').modal('show')

  hideModal: =>
    @$el.find('#tags-hierarchy-modal').modal('hide')

  onChangeTagsLogic: (evt) ->
    selectedOption = @$el.find("input[name=tags-logic]:checked")
    @logic = selectedOption.attr('value')

  tagDescription: (tag) ->
    return '(N/A)' unless tag # It could happen that some applied tag is not available anymore...
    tag.description || tag.code || '(N/A)'
